import { Helmet } from 'react-helmet-async'
import { BentoGrid, BentoGridItem } from '../components/ui/BentoGrid'
import GrantaEarthLogo from '../components/ui/GrantaEarthLogo'

export default function Energy() {
  return (
    <>
      <Helmet>
        <title>Energy | GrantaEarth Co.</title>
        <meta name="description" content="Bulk fuel trader supplying wholesale customers with dependable delivery and contract structures." />
      </Helmet>

      <section className="bg-gradient-to-b from-off-white to-white section-padding">
        <div className="container-custom">
          <div className="text-center mb-8">
            <GrantaEarthLogo size="lg" className="mx-auto mb-6" />
          </div>
          
          <h1 className="text-3xl md:text-5xl font-extrabold text-center">Energy Trading</h1>
          <p className="mt-4 text-center text-gray-700 max-w-3xl mx-auto">
            Bulk fuel supply for transport, agriculture, and industry. Structures that improve predictability for counterparties.
          </p>

          <div className="mt-10">
            <BentoGrid>
              <BentoGridItem 
                title="Wholesale Focus" 
                description="Contract supply for fleet operators and industrial buyers. Competitive pricing through volume commitments and strategic partnerships."
                icon="⛽"
              />
              <BentoGridItem 
                title="Logistics Excellence" 
                description="Delivery partners that meet schedule and quality requirements. Reliable supply chain management across the region."
                icon="🚛"
              />
              <BentoGridItem 
                title="Risk Management" 
                description="Structures that manage currency and lead time exposure. Hedging strategies to protect both buyers and suppliers."
                icon="📊"
              />
            </BentoGrid>
          </div>
        </div>
      </section>
    </>
  )
}
